<template>
  <v-progress-circular v-if="loading" indeterminate color="primary">
  </v-progress-circular>
  <div v v-else-if="content" v-html="content"></div>
  <div v-else class="text-default">
    <span class="center title">CONTRATO DE ADHESIÓN A LA PRESTACIÓN DE SERVICIOS</span><br/>
    <span class="right">Barcelona a {{ params.date }}</span><br/>
    <span class="second-title">EL PRESTADOR</span><br/>
    <span>CONEPTUM S.L., NIF B-65946956</span><br/><br/>

    <span>calle Sant Agustí número 3-5 Barcelona</span><br/><br/>

    <span class="second-title">EL CLIENTE</span><br/>
    <span>{{ params.business_name }}, {{ params.bussnies_id }}</span><br/><br/>

    <span>{{ params.postal_address }} - {{ params.province }}</span><br/><br/>

    <span class="center second-title">Preámbulo</span><br/>
    <span>Que la mercantil Coneptum ha desarrollado una plataforma tecnológica que ofrece soluciones a empresas y profesionales. La plataforma se denomina INMATIC y es un procesador automático de contabilización de facturas y documentos análogos.</span><br/><br/>

    <span>Este contrato está compuesto por el presente documento y sus anexos, que serán considerados parte inseparable del mismo.</span><br/><br/>

    <span class="center second-title">ESTIPULACIONES</span><br/>
    <ol>
      <li>
        <span>Objeto</span>
        <ol type="a">
          <li>
            El objeto del presente contrato es la regulación de los términos y condiciones en los que Coneptum provisionará y prestará sus Servicios al Cliente, así como la especificación de sus detalles técnicos y características.
          </li>
          <li>
            Todos los Servicios prestados por Coneptum están regulados y se regirán por las estipulaciones recogidas en el presente Contrato. No obstante, lo anterior, debido a la heterogeneidad o complejidad técnica, algunos Servicios pueden estar sujetos a condiciones particulares de contratación que serán integradas al presente contrato como Anexo.
          </li>
        </ol>
      </li>
      <li>
        <span>Servicio</span><br/>
        <span>Descripción del producto</span><br/><br/>

        <span>INMATIC es una solución que permite mediante un escaneo del documento y de forma automática la contabilización en el programa contable de facturas, tickets de gastos e ingresos y otros documentos análogos.</span><br/><br/>

        <span>Especificaciones del programa:</span><br/><br/>

        <span>Contabiliza facturas de profesionales, tickets de caja, facturas con retenciones, Iva y otros impuestos.</span><br/><br/>

        <span>Dentro de las funciones estándares se encuentra la extracción de los siguientes ítems:</span><br/><br/>

        <span>- Proveedor/Cliente</span><br/>
        <span>- Nif proveedor y Nif cliente</span><br/>
        <span>- Número de la factura</span><br/>
        <span>- Fecha de la factura</span><br/>
        <span>- Fecha de vencimiento de la factura</span><br/>
        <span>- Base imponible</span><br/>
        <span>- IVA/IGIC</span><br/>
        <span>- Total de la factura</span><br/>
        <span>- Retención de IRPF</span><br/><br/>

        <span>La contratación del servicio de INMATIC, conlleva la integración de esta funcionalidad al programa que indique el cliente, siempre que no haya alguna incompatibilidad</span><br/><br/>
      </li>
      <li>
        <span>Duración de los Servicios</span><br/>
        <span>La duración del Contrato de Servicio será de doce (12) meses a contar desde su entrada en vigor y será renovado de forma automática por periodos de igual tiempo, salvo que cualquiera de las Partes notifique a la otra Parte su deseo de no renovarlo con una antelación mínima, de 30 días naturales. Se acuerda que la notificación a través de correo electrónico para prorrogar o resolver el contrato será aceptada como medio de comunicación válido entre las partes.</span><br/><br/>

        <span>El servicio se considera un servicio (Saas) “software as a service”, con lo que se entenderá que, si el servicio no se paga, se deja de obtener el servicio, siempre que el Cliente no atienda al requerimiento de pago del proveedor.</span><br/><br/>

        <span>Una vez el Cliente acepta y firma el contrato, le llega un correo electrónico el cual irá con las indicaciones de como acceder a la plataforma y poder operar con los servicios contratados.</span><br/><br/>
      </li>
      <li>
        <span>Pago de los Servicios</span>
        <ol type="a">
          <li>
            <span>La Cuota del servicio, es decir el pago recurrente que el Cliente debe realizar de forma periódica por la prestación del Servicio, se facturará de forma anticipada el día 1 de cada período. El pago se realizará de la forma indicada en el anexo adjunto al presente contrato.</span>
          </li>
          <li>
            <span>El período de facturación será indicado en el referido anexo de datos.</span>
          </li>
          <li>
            <span>Todas las transacciones económicas se realizarán en euros.</span>
          </li>
          <li>
            <span>A los precios señalados se les sumarán los impuestos aplicables en cada caso.</span>
          </li>
        </ol>
      </li>
      <li>
        <span>Funcionamiento del programa</span>
        <ol type="a">
          <li>
            <span>INMATIC es un procesador de contabilización de facturas, tickets y/o documentos análogos, en adelante documento, cada vez que se procesa un documento el programa descuenta del saldo de paquete contratado y una vez llega al 90% de documentos contabilizados aparece un pop up en el programa a la vez que se envía un correo electrónico comunicando que el saldo contratado está a punto de ser agotado.</span>
          </li>
          <li>
            <span>El paquete de documentos contratados para contabilizar tiene la misma vigencia que el contrato, en ningún caso podrá ser acumulado el saldo no consumido fuera del año de vigencia del contrato.</span>
          </li>
        </ol>
      </li>
      <li>
        <span>Interrupción del Servicio</span>
        <ol type="a">
          <li>
            <span>Coneptum se reserva el derecho a suspender temporalmente la prestación del Servicio para realizar labores de mantenimiento o mejora, notificándolo de forma anticipada al Cliente con al menos 24 horas de antelación.</span>
          </li>
          <li>
            <span>El cliente se compromete a facilitar una ventana horaria de mantenimiento trimestral y otra mensual para el parcheado general y el crítico respectivamente.</span>
          </li>
          <li>
            <span>No obstante, no se notificará de forma previa al Cliente, si dichas labores se realizan como respuesta a un problema grave o que afecte de forma drástica a la seguridad de la infraestructura, y, por tanto, Coneptum deba actuar de forma inmediata sin posibilidad de realizar la notificación previa.</span>
          </li>
          <li>
            <span>Del mismo modo, Coneptum se reserva el derecho a interrumpir temporalmente el Servicio sin previo aviso si observase:</span>
            <ol>
              <li>
                <span>Un uso ilícito del Servicio o contrario a lo establecido en los Documentos del Servicio o a sus Políticas de uso.</span>
              </li>
              <li>
                <span>Un uso indebido o abusivo del Servicio.</span>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <span>Soporte técnico</span><br/>
        <span>Coneptum ofrece un servicio técnico base para cualquier cuestión del producto INMATIC que le pueda surgir al Cliente. La atención básica es en los días laborales de lunes a viernes dentro del horario comercial de 9 a 18 horas. Esta atención será mediante un correo electrónico y Coneptum valorará en cada una de las consultas si es necesario atender por otro medio que no sea el electrónico.</span><br/><br/>

        <span>Correo electrónico soporte@inmatic.ai</span><br/><br/>
      </li>
      <li>
        <span>Responsabilidades</span>
        <ol type="a">
          <li>
            <span>Coneptum se compromete a realizar sus mejores esfuerzos, en el ejercicio de sus funciones, para asegurar el buen funcionamiento de los Servicios pero no será responsable de circunstancias o eventos que se encuentren fuera de su control, tales como el caso fortuito o fuerza mayor.</span>
          </li>
          <li>
            <span>Coneptum no se responsabiliza de fallos en el servicio como consecuencia de caídas del servicio del servidor del cliente derivados de un uso excesivo o erróneo de los recursos del mismo o de los recursos asignados al mismo, ataques externos o de terceras personas, fallos del software o similares.</span>
          </li>
          <li>
            <span>En ningún caso Coneptum será responsable de pérdidas de datos, interrupción de negocio o cualesquiera otros perjuicios producidos por el funcionamiento del Servicio que sea ajeno a la ejecución de Coneptum, o por no cumplir éste con las expectativas del Cliente.</span>
          </li>
          <li>
            <span>Coneptum no se responsabiliza de fallos en el servicio como consecuencia de que el Cliente no haya permitido la realización por parte de Coneptum del mantenimiento trimestral indicado.</span>
          </li>
          <li>
            <span>Ninguna de las Partes será responsable por el incumplimiento del presente Contrato si ello obedece a causas de Fuerza Mayor.</span>
          </li>
          <li>
            <span>Serán considerados como casos de fuerza mayor o caso fortuito, sin carácter limitativo, el retraso, fallo, suspensión o interrupción de los Servicios como consecuencia de las restricciones de energía, bloqueo de las telecomunicaciones o de la red Internet, acciones u omisiones de terceras personas, operadores de telecomunicaciones o compañías de servicios, suministro o transportes o cualesquiera otras causas o circunstancias independientes de la voluntad de Coneptum que impida la ejecución normal del presente contrato. </span>
          </li>
        </ol>
      </li>
      <li>
        <span>Garantías</span>
        <ol type="a">
          <li>
            <span>Coneptum se compromete a prestar los servicios contratados con la máxima diligencia, utilizando personal con la debida experiencia y preparación, en cumplimiento de los procedimientos internos de Coneptum.</span>
          </li>
          <li>
            <span>Se consideran fuera del control de Coneptum, entre otros, los siguientes elementos o recursos:</span>
            <ol>
              <li>
                <span>El sistema informático del usuario/s.</span>
              </li>
              <li>
                <span>El software contable del cliente.</span>
              </li>
              <li>
                <span>Software de navegación o de conexión y accesorios.</span>
              </li>
              <li>
                <span>Virus, troyanos, gusanos o cualquier otro programa informático hostil, nocivo o perjudicial.</span>
              </li>
              <li>
                <span>Red telefónica conmutada, RDSI, línea punto a punto, cable, satélite y cualquier otra infraestructura de transporte telecomunicaciones.</span>
              </li>
            </ol>
          </li>
          <li>
            <span>Ley aplicable y jurisdicción</span>
          </li>
        </ol>
      </li>
      <li>
        <span>Ley aplicable y jurisdicción</span><br/>
        <span>El presente contrato se regirá e interpretará de acuerdo con las Leyes de España y se someterá a la jurisdicción de los Tribunales de Barcelona.</span><br/><br/>
      </li>
    </ol>

    <span class="center second-title">ANEXO SERVICIOS CONTRATADOS</span><br/>
    <span class="second-title">Relación de servicios:</span><br/>
    <div class="table-header">
      <span class="third-title">Servicios contratados</span>
    </div>
    <div class="equal-space">
      <span class="table-first-item">Servicio contratado</span>
      <span class="table-others-items">Cantidad</span>
      <span class="table-others-items">Precio</span>
      <span class="table-others-items">Forma de pago</span>
    </div>
    <div v-for="(item, index) in params.services_selected" class="equal-space">
      <span class="table-first-item">{{item.name}}</span>
      <span class="table-others-items">{{item.quantity}}</span>
      <span class="table-others-items">{{item.price}}€</span>
      <span class="table-others-items">AÑO P/ADELANTADO</span>
    </div>
    <span>*Impuestos no incluidos</span><br/><br/><br/>


    <span>Forma de pago:</span><br/><br/>

    <span>El primer año se realizará mediante transferencia a la siguiente cuenta:</span><br/><br/>

    <span>Banc Sabadell – ES04 0081 0400 1100 0123 0926</span><br/><br/>

    <span>Cumplido el primer año de contrato, la Compañía se reserva el derecho de regular el importe mensual en el marco del contrato anual, así como la modalidad de pago, notificándoselo al Cliente a través de un correo electrónico, con efecto a partir de los 30 (treinta) días desde que se realizó la comunicación.</span><br/><br/>

    <span>El Cliente tendrá un plazo de 7 días de prueba contados a partir de la activación de la Plataforma donde podrá procesar hasta un máximo de 100 documentos. Cumplido dicho plazo o habiendo alcanzado los 100 documentos procesados, en caso de querer seguir con la contratación, se le enviará una factura que deberá abonar mediante transferencia bancaria a la cuenta antes indicada.</span><br/><br/>

    <span>En caso de no estar conforme con el programa, deberá notificar la desactivación del mismo mediante notificación por correo electrónico a soporte@inmatic.ai.</span><br/><br/>

    <div class="separation-space">
      <div class="signature">
        <span>Coneptum S.L</span><br/><br/>
        <span>Antonio Bagur Cantallops</span>
      </div>
      <div class="signature">
        <span>{{ params.business_name? params.business_name: params.name }}</span><br/><br/>
        <span>{{ params.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';

export default {
  name: "LegalContract",
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({})
    },
    kind: String,
    api: {
      type: String,
      required: false,
      default: "get_lastest_legal_contract"
    },
  },
  async mounted() {
    this.init({ params: this.params, api: this.api, kind: this.kind }).then((response) => {
      this.$emit('contract-data', response.data);
    })
  },
  methods: {
    ...mapActions({
      init: "legal_contract/init",
    }),
  },
  computed: {
    ...mapFields('legal_contract', ['content', 'loading']),
  },
};
</script>

<style scoped>
.center{
  display: flex;
  justify-content: center;
}

.title{
  font-size: 16px;
  font-weight: bold;
}

.right{
  display: flex;
  justify-content: end;
}

.second-title{
  font-size: 1.10em;
  font-weight: bold;
}

.third-title{
  font-size: 16px;
  font-weight: bold;
}

.text-default{
  font-size: 16px;
}

.separation-space{
  display: flex;
  gap: 600px;
  justify-content: center;
}

.signature{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-header{
  display: flex;
  justify-content: center;
  border: 1px solid black;
  box-sizing: border-box;
  padding: 10px 0px;
}

.equal-space{
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}

.table-first-item{
  display: flex;
  justify-content: center;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
}

.table-others-items{
  display: flex;
  justify-content: center;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
}

::v-deep table {
  border: 1px solid black;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  text-align: center;
  pointer-events: none;
}

::v-deep table tr {
  border: 1px solid black;
  padding: .35em;
}

::v-deep table th,
::v-deep table td {
  padding: .625em;
  border: 1px solid black;
}

::v-deep table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}
</style>
